import { loadElementLazyImage } from './global'


// archive

let load_more = $('.js-load-more')

if (load_more.length){

  function loadMore(){
    let cat = load_more.data('cat')
    let per_page = load_more.data('per-page')
    let page = load_more.attr('data-page')
    let order = load_more.attr('data-order')
    let results_c = $('.js-search-results')

    load_more.find('span').css('opacity', 0)
    load_more.find('.loader').fadeIn(200)

    $.ajax({
      url: localize_script['ajax_url'],
      type:'POST',
      data:'action=load-davanas&cat='+ cat + '&per_page='+ per_page + '&page='+page+'&order='+order,
      success:function(results) {
        results_c.append($(results.content_data))
        loadElementLazyImage(results_c.find('.lazy'))
        if (results.tot_pages <= page * per_page) {
          load_more.fadeOut()
        } else {
          load_more.fadeIn()
        }
        page++
        load_more.attr('data-page', page)

        load_more.find('.loader').fadeOut(200, function(){
          load_more.find('span').css('opacity', 1)
        })
      }
    });
  }

  load_more.click(loadMore)
  loadMore()
}



// open product
$(document).on('click','.js-product-el',function(e){
  let id = $(this).data('id')

  $.ajax({
    url: localize_script['ajax_url'],
    type:'POST',
    data:'action=product-click&id='+ id,
    success:function(results){}
  });

})


$('.js-suggest-company-form').submit(function (e){
  e.preventDefault()

  let error_text = $(this).find('.error-text')
  let error_ic = $(this).find('.warning')
  let success_ic = $(this).find('.success')
  let loading = $(this).find('.loader')
  let form = this
  let formData = new FormData(form);
  let success_text = $(form).find('.success-text')

  error_ic.css('display', 'none')
  $(form).find('.input-c').removeClass('error')

  if ($(this).find('input[name="company"]').val() !== ''){
    loading.fadeIn(200)
    $.ajax({
      url: localize_script['ajax_url'],
      type: 'POST',
      data: formData,
      async: false,
      cache: false,
      contentType: false,
      enctype: 'multipart/form-data',
      processData: false,
      success: function (response) {
        loading.css('display', 'none')
        if (response.error === ''){
          success_ic.fadeIn()
          success_text.fadeIn()
          $(form).find('button').fadeOut(400)
          setTimeout(function(){
            success_text.fadeOut()
            $(form).find('button').fadeIn()
            $(form).find('input[name="company"]').val('').change().blur()
            success_ic.fadeOut()
          }, 2000)
        } else {
          error_text.text(response.error)
          error_ic.fadeIn()
          $(form).find('.input-c').addClass('error')
        }
      }
    })
  } else {
    error_ic.fadeIn()
    error_text.text(error_text.attr('data-error'))
    $(form).find('.input-c').addClass('error')
  }

  return false;
})
